export default {
  navigationBarTitleText: '发表评价'
};
